












import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  setup(_props, { emit }) {
    const feedbackInput = ref('');

    const handleFeedback = () => {
      emit('feedback', feedbackInput.value);
    };

    return {
      feedbackInput,
      handleFeedback,
    };
  },
});
